import React, { useEffect, useState } from 'react'
import ClipLoader from "react-spinners/ClipLoader";
import { Login as APILogin } from '../api/auth'
import { Formik } from "formik";
import * as Yup from "yup";
import { Form, Alert } from 'react-bootstrap'

const schema = Yup.object().shape({
    email: Yup.string()
        .required("Email is a required field")
        .test("format", "Invalid email format", (value) => {
            if (!value) return false;

            const emailRegex = /^[\w.+-]+@[\w.-]+\.\w+$/;
            const customRegex = /^([\w.-]+@[\w.-]+\.\w+)@(\d+)$/;

            return emailRegex.test(value) || customRegex.test(value);
        }),
    password: Yup.string()
        .required("Password is a required field")
});


export default function Login(props) {

    const [loginError, setLoginError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [IpAddress, setIPAddress] = useState('');

    useEffect(() => {
        (async () => {
            try {
                let ip = await (await fetch('https://api64.ipify.org?format=json')).json();
                setIPAddress(ip.ip || "")
            } catch (ex) {
                setIPAddress("")
            }
        })()
    });
    return (
        <>

            <Formik
                validationSchema={schema}
                initialValues={{ email: "", password: "" }}
                onSubmit={async (values) => {
                    setSubmitting(true);
                    let _login = await APILogin({ ...values, 'ip': IpAddress });
                    if (_login.Code === 0) {
                        const queryParams = new URLSearchParams(window.location.search);
                        window.location.href = queryParams.get(`return_url`) ?? `/my-account`;
                    } else {
                        setLoginError(_login.error_message ?? `There was an issue logging in.  Please try again later.`);
                    }
                    setSubmitting(false);

                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                }) => (
                    <div className="login">
                        <h2>Login</h2>
                        <div className="form">
                            {loginError && <Alert transition={null} variant={'danger'}>{loginError}</Alert>}
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group controlId="email" className={`col-md-10`}>
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control type="email" value={values.email} placeholder={`Email Address`} name={"email"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.email}></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.email && touched.email && errors.email}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="password" className={`col-md-10`}>
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type='password' value={values.password} placeholder={`Password`} name={"password"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.password}></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.password && touched.password && errors.password}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <button type="submit" class={`gc-btn primary-action`}>Login {submitting && <ClipLoader size={`18`} color={`#fff`} />}</button>
                            </Form>
                            <p class={`small`}>
                                <a href={`/login/forgot-password`}>Forgot your password?</a>
                            </p>
                        </div>
                    </div>
                )}
            </Formik>
        </>
    );

}